module.exports = __webpack_public_path__ + "static/img/card_bg.a325010.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/card_bg.png
// module id = lA+m
// module chunks = 0